<template>
  <ion-content scroll-y="false">
    <div class="splash-container">
      <HOGCLogo is-animation="true" />

      <!-- Only while a live update is downloading. A normal open renders
           exactly as before: no bar, no copy, no added delay. -->
      <div v-if="updating" class="splash-updating">
        <p class="splash-updating__label">Updating</p>
        <div class="splash-updating__track">
          <div class="splash-updating__fill" :style="{ width: `${clampedPercent}%` }"></div>
        </div>
      </div>
    </div>
    <slot></slot>
  </ion-content>
</template>

<script>
import HOGCLogo from '@/components/HOGCLogo.vue';

export default {
  name: 'SplashScreen',
  components: {
    HOGCLogo,
  },
  props: {
    updating: {
      type: Boolean,
      default: false,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    clampedPercent() {
      if (!Number.isFinite(this.percent)) return 0;
      return Math.min(100, Math.max(0, this.percent));
    },
  },
};
</script>

<style scoped>
ion-content {
  --ion-background-color: #fec629;
}

.splash-container {
  background-color: #fec629;
  min-height: 100vh;
}

.splash-updating {
  position: absolute;
  bottom: calc(48px + env(safe-area-inset-bottom, 0px));
  left: 0;
  right: 0;
  padding: 0 48px;
  text-align: center;
}

.splash-updating__label {
  margin: 0 0 12px;
  font-size: 14px;
  color: #191817;
  opacity: 0.7;
}

.splash-updating__track {
  height: 4px;
  border-radius: 2px;
  background-color: rgba(25, 24, 23, 0.15);
  overflow: hidden;
}

.splash-updating__fill {
  height: 100%;
  border-radius: 2px;
  background-color: #191817;
  /* Eases the jumps a delta download produces, where whole groups of files
     complete at once. */
  transition: width 200ms ease-out;
}
</style>
